import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import Index from "./pages/Index";
import AmendmentReport from "./pages/AmendmentReport";
import SystemAdministratorArea from "./pages/SystemAdministratorArea";
import AllocationPage from "./pages/AllocationPage";
import LoginPage from "./pages/LoginPage";
import ParliamentarianArea from "./pages/ParliamentarianArea";
import InstitutionArea from "./pages/InstitutionArea";
import GestorArea from "./pages/GestorArea";
import ApiDocs from "./pages/ApiDocs";
import ApiTokens from "./pages/ApiTokens";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import LoadingScreen from "./components/LoadingScreen";
import { listenAuth } from "@/services/auth";

const queryClient = new QueryClient();

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsub = listenAuth(() => {
      setIsLoading(false);
    });
    return () => {
      try { (unsub as unknown as () => void)(); } catch { }
    };
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/inicio" element={<Index />} />
            <Route path="/relatorio" element={<AmendmentReport />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <SystemAdministratorArea />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alocar"
              element={
                <ProtectedRoute allow={["vereador", "admin"]}>
                  <ParliamentarianArea />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/vereador"
              element={
                <ProtectedRoute allow={["vereador", "admin"]}>
                  <ParliamentarianArea />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instituicao"
              element={
                <ProtectedRoute allow={["instituicao", "admin"]}>
                  <InstitutionArea />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestor"
              element={
                <ProtectedRoute allow={["gestor", "admin"]}>
                  <GestorArea />
                </ProtectedRoute>
              }
            />
            <Route path="/api-docs" element={<ApiDocs />} />
            <Route
              path="/admin/api-tokens"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <ApiTokens />
                </ProtectedRoute>
              }
            />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
